<template>
  <main class="main">
    <router-view />
    <ProgramDetailModal v-model="state" :mode="mode" :item="item" :future-programs="futurePrograms" />
  </main>
  <TheTabBar />
</template>

<script setup lang="ts">
import { inject } from 'vue';
import TheTabBar from '@/components/organisms/TheTabBar.vue';
import ProgramDetailModal from '@/components/organisms/schedule/ProgramDetailModal.vue';
import { ProgramModalKey } from '@/composables/useProgramModal';

const programModalInjection = inject(ProgramModalKey);
if (!programModalInjection) throw new Error(`${ProgramModalKey} NOT PROVIDE`);
const { item, state, mode, futurePrograms } = programModalInjection;
</script>

<style scoped lang="scss">
.main {
  min-height: calc(100vh - $tab-bar-height);
}
</style>
